// extracted by mini-css-extract-plugin
export var actionButton = "_iq-0";
export var fileInput = "_iq-2";
export var paperclip = "_iq-1";